// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyBfv7jfhgmCvPG0L9L8Detrg6nlHwL_RdE",
    authDomain: "excelcomms-panel-ote.firebaseapp.com",
    databaseURL: "https://excelcomms-panel-ote.firebaseio.com",
    projectId: "excelcomms-panel-ote",
    storageBucket: "excelcomms-panel-ote.appspot.com",
    messagingSenderId: "951262586803"
  }
};
